module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _c('glitch', {
    attrs: {
      "text": "Glitch"
    }
  }), _c('glitch', {
    attrs: {
      "text": "Glitch with custom color",
      "color": "tomato"
    }
  }), _c('glitch', {
    attrs: {
      "text": "Glitch with custom background",
      "background": "steelblue"
    }
  }), _c('div', [_c('h3', [_vm._v("### Component Usage")]), _c('pre', [_c('code', {
    domProps: {
      "textContent": _vm._s(_vm.sourcecode1)
    }
  })]), _c('pre', [_c('code', {
    domProps: {
      "textContent": _vm._s(_vm.sourcecode2)
    }
  })]), _c('pre', [_c('code', {
    domProps: {
      "textContent": _vm._s(_vm.sourcecode3)
    }
  })])]), _vm._m(1), _vm._m(2), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("# vue-glitch"), _c('br'), _c('small', [_vm._v("> Vue.js component to apply glitch effect in any kind of text.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("### Component Properties")]), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _c('th', [_vm._v("required")]), _c('th', [_vm._v("default")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v("text")]), _c('td', [_vm._v("true")]), _c('td', [_vm._v("N/A")])]), _c('tr', [_c('td', [_vm._v("color")]), _c('td', [_vm._v("false")]), _c('td', [_vm._v("#fff")])]), _c('tr', [_c('td', [_vm._v("background")]), _c('td', [_vm._v("false")]), _c('td', [_vm._v("#000")])]), _c('tr')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("### Component Styling")]), _c('p', [_vm._v("> To apply custom styles you should care about "), _c('code', [_vm._v(".glitch")]), _vm._v(" and "), _c('code', [_vm._v(".glitch-wrapper")]), _vm._v(" classes.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "color": "#fff",
      "margin-top": "50px"
    }
  }, [_c('p', [_vm._v("You can find more information in "), _c('a', {
    attrs: {
      "href": "https://github.com/ianaya89/vue-glitch"
    }
  }, [_vm._v("component repository.")])]), _c('p', [_vm._v("⌨️ with ❤️ by "), _c('a', {
    staticStyle: {
      "color": "steelblue"
    },
    attrs: {
      "href": "http://twitter.com/ianaya89"
    }
  }, [_vm._v("ianaya89")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18311b62","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/App.vue
// module id = 11
// module chunks = 0